<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="检索对象">
        <el-radio v-model="is_title_sub" :label="false">商品标题</el-radio>
        <el-radio v-model="is_title_sub" :label="true">商品副标题</el-radio>
      </el-form-item>

      <el-form-item v-if="is_title_sub" label="关键词" prop="title_sub">
        <el-input
          v-model="postData.title_sub"
          maxlength="21"
          show-word-limit
          clearable
          placeholder="请输入副标题关键词"
        />
        <el-alert
          title="当有赞商品副标题包含此关键词，则在下方设置的日期可签到"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item v-else label="关键词" prop="title">
        <el-input
          v-model="postData.title"
          maxlength="21"
          show-word-limit
          clearable
          placeholder="请输入标题关键词"
        />
        <el-alert
          title="当有赞商品标题包含此关键词，则可签到"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="可签到日期" prop="sign_date">
        <el-date-picker
          v-model="postData.sign_date"
          :picker-options="pickerOptionsOfAfterSystemStartDay"
          type="date"
          value-format="yyyy-MM-dd"
          align="right"
          placeholder="请选择所属日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.youZanSignDateList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/you-zan-sign-date';
import { pickerOptionsOfAfterSystemStartDay } from "@/utils/formats";

export default {
  name: RouteConfig.youZanSignDateAdd.name,
  data: () => ({
    RouteConfig,
    pickerOptionsOfAfterSystemStartDay,
    is_title_sub: false,
    isSaving: false,
    postData: {
      title: '',
      title_sub: '',
      sign_date: '',
    },
    rules: {
      title: [{ required: true, message: '请输入标题关键词', trigger: 'change' }],
      title_sub: [{ required: true, message: '请输入副标题关键词', trigger: 'change' }],
      sign_date: [{ required: true, message: '请选择可签到日期', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { is_title_sub, postData } = this;
        const data = { ...postData };
        this.isSaving = true;
        const { isError } = await store({
          title: is_title_sub ? '' : data.title,
          title_sub: is_title_sub ? data.title_sub : '',
          sign_date: data.sign_date,
        });
        this.isSaving = false;
        if (!isError) RouteConfig.youZanSignDateList.push();
      });
    },
  },
};
</script>
